import React, { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute:FC = () => {
  const { currentUser, isAuthorized } = useAuth();

  // If not logged in or not authorized, redirect to login
  if (!currentUser || !isAuthorized) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute; 